import { useMutation } from '@tanstack/react-query';
import { ChangeSetPayload } from 'src/features/locations/scheduleComponentPage/ScheduleComponentPage.interface';
import { requestCCApi } from 'src/utils';

export const useCreateChangeSet = () => {
  return useMutation({
    mutationFn: async (payload: ChangeSetPayload) => {
      const response = await requestCCApi({
        url: '/changeSets',
        method: 'POST',
        data: { data: payload },
      });

      return response;
    },
  });
};
